import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../../history'

import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
// import { deleteFeed } from '../../../Api/backendApi'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import GenericCard from '../../../GenericComponents/GenericMainCard'

interface ContactModalInterface {
  closeModal: Function
  contactAdress: string
}

const ContactModal: FC<ContactModalInterface> = ({
  closeModal,
  contactAdress,
}) => {
  return (
    <GenericCard
      flexDir={'column'}
      className="standard"
      width={'100%'}
      margin={' auto'}
    >
      <GenericCloseButton onClick={closeModal} />

      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Kontakt
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'1.4rem'}
          margin={'1% 0 0 0'}
          fWeight={'normal'}
          width={isMobile ? '90%' : '60%'}
          wordBreak={'break-word'}
        >
          By skontaktować się, napisz wiadomość na podany niżej adres email.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow margin="4% 0 5% 0">
        <GenericTextSpan
          className="email color-green"
          fSize={isMobile ? '1.7rem' : '2.6rem'}
        >
          {contactAdress}
        </GenericTextSpan>
      </GenericRow>
    </GenericCard>
  )
}

export default ContactModal
